export enum DisplayMode {
  "DISPLAY" = "display",
  "EDIT" = "edit",
}

export enum TestStatus {
  "PASS" = "pass",
  "FAIL" = "fail",
}